import { type CheckboxPermission } from "@/types/modular-permissions.types";
import { HexString } from "@/types/general.types";
import chunkArray from "@/utils/chunkArray";

// Config
export const BLESSNET_ACCOUNT_FACTORY =
  "0x0000000000006C04E4D22125B7cDd6C2d14a90c1";

export const BLESSNET_RPC = "https://blessnet.calderachain.xyz/http";

//? Same on sepolia
export const BLESSNET_MOD_PERMS_ADDRESS = process.env
  .NEXT_PUBLIC_BLESSNET_MOD_PERMS_ADDRESS as HexString;

export const BLESSNET_BLESS_API_KEY = process.env.BLESSNET_API_KEY as string;

// Select all id (typically 1)
export const PERMISSION_MOD_SELECT_ALL_ID = 1;

// Dialogues & Prompts
export const REMOVE_ALL_GRANTED_PERMS_DIALOGUE =
  "Are you sure you want remove all granted permissions?";
export const REMOVE_ALL_RECEIVED_PERMS_DIALOGUE =
  "Are you sure you want to remove all received permissions?";
export const REMOVE_SINGLE_PERM_DIALOGUE =
  "Please confirm you want to remove this permission";

// Chain ids -> names
export const CHAIN_ID_TO_NAMES: { [chainId: number]: string } = {
  1: "mainnet",
  45513: "blessnet",
  11155111: "sepolia",
  11145513: "blessnet sepolia",
};

export const PROTOCOL_TO_NAME: { [protocol: string]: string } = {
  XYZV1: "delegate.xyz v1",
  XYZV2: "delegate.xyz v2",
  EPSV1: "eternal proxy service v1",
  EPSV2: "eternal proxy service v2",
};

export const PERMISSION_LIST: CheckboxPermission[] = [
  {
    name: "All",
    id: PERMISSION_MOD_SELECT_ALL_ID,
  },
  {
    name: "Allowlists",
    id: 2,
  },
  {
    name: "Airdrops",
    id: 3,
  },
  {
    name: "Voting",
    id: 4,
  },
  {
    name: "Avatar",
    id: 5,
  },
  {
    name: "Socials",
    id: 6,
  },
  {
    name: "Events",
    id: 7,
  },
  {
    name: "Land",
    id: 11,
  },
  {
    name: "Games",
    id: 12,
  },
  {
    name: "IP",
    id: 13,
  },
  {
    name: "Approvals",
    id: 14,
  },
];

export const GROUPED_PERMISSIONS = chunkArray(PERMISSION_LIST) as Array<
  CheckboxPermission[]
>;
export const COLORS: string[] = ["#54AAC9", "#546BC9", "#c374eb", "#2ebbf8"];
